import {Grid} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
import queryString from "query-string";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Betriebsdaten from "../../components/betriebsakte/betrieb/Betriebsdaten";
import FreigabeDialog from "../../components/betriebsakte/betrieb/FreigabeDialog";
import StilllegenDialog from "../../components/betriebsakte/betrieb/StilllegenDialog";
import Wasserversorgung from "../../components/betriebsakte/betrieb/Wasserversorgung";
import Zustaendigkeiten from "../../components/betriebsakte/common/Zustaendigkeiten";
import EABetriebsakteDatenContainer from "../../components/betriebsakte/EABetriebsakteDatenContainer";
import EABetriebsakteMainContainer from "../../components/betriebsakte/EABetriebsakteMainContainer";
import {useConfirmation} from "../../components/ConfirmationDialog/ConfirmationDialogProvider";
import EAButton from "../../components/EAButton";
import EAButtonBar from "../../components/EAButtonBar";
import EADialog from "../../components/EADialog";
import EATabs from "../../components/EATabs";
import AuditInfoDialog from "../../components/historie/AuditInfoDialog";
import EAHistorySelector from "../../components/historie/EAHistorySelector";
import {INDUSTRIE} from "../../consts/betriebstyp";
import {isFinalStatus} from "../../consts/fachobjektstatus";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../consts/funktionaleRollen";
import routes from "../../consts/routes.json";
import {createBetriebSchema, createInitialBetrieb} from "../../initialObjects/BetriebObjects";
import {
    deleteStammdatenAntrag,
    getBetriebEndpoint,
    getBetriebHistorie,
    getStammdatenAntragEndpoint,
    postBetrieb,
    postFreigabe,
    postStammdaten,
    putBetrieb,
    putBetriebsdaten,
} from "../../services/BetriebeService";
import {handleApiException, isApiCancel, useHttp} from "../../services/HttpService";
import {logger} from "../../services/LogService";
import {createCalculatedColumn} from "../../utils/ColumnUtils";
import {useForm} from "../../utils/FormUtils";
import {userHasAnyRole} from "../../utils/SecurityUtils";
import {leftPad} from "../../utils/StringUtils";

function BetriebsdatenView(props) {
    const confirm = useConfirmation();
    const tabBetrieb = "Betrieb";
    const tabWasserversorgung = "Wasserversorgung";
    const tabZustaendigkeiten = "Zuständigkeiten";
    const {stammdatenAntrag} = queryString.parse(props.location.search);
    const readonly = !props.betriebsId ? false : props.modus === "l";
    const [freigabeNeeded, setFreigabeNeeded] = useState(false);
    const {values, setValues, errors, setErrors, formFactory, validate, validateProperty, touchedValues, setTouchedValues} = useForm({
        initialValues: createInitialBetrieb(props.betriebstyp),
        schema: createBetriebSchema(),
        readonly,
    });

    // Historie
    const [auditInfoDialogOpen, setAuditInfoDialogOpen] = useState(false);
    const [auditInfoDialogViolation, setAuditInfoDialogViolation] = useState({art: "MISSING", faultyAuditInfo: {}});
    const [{data: historyData, loading: historyLoading}, refetchHistoryData] = useHttp(getBetriebHistorie(props.betriebsId), {manual: !props.betriebsId});

    const [currentVersion, setCurrentVersion] = useState(null);
    const [selectedTab, setSelectedTab] = useState(tabBetrieb);
    const [stilllegenDialogOpen, setStilllegenDialogOpen] = useState(false);
    const [freigabeDialogOpen, setFreigabeDialogOpen] = useState(false);
    const [freigabeKommentar, setFeigabeKommentar] = useState("");
    const [saveActionLoading, setSaveActionLoading] = useState(false);
    const [betriebLoader, reFetchBetrieb] = useHttp(getBetriebEndpoint(props.betriebsId), {manual: !props.betriebsId});
    const [stammdatenAntragLoader] = useHttp(getStammdatenAntragEndpoint(props.betriebsId), {
        manual: !(props.betriebsId && userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])),
    });
    const {
        values: stammdatenantrag,
        setValues: setStammdatenantrag,
        setErrors: setStammdatenErrors,
        formFactory: innerFormFactory,
    } = useForm({});
    const [dlgRequestChangeOpen, setDlgRequestChangeOpen] = useState(false);
    const [dlgApproveChangeOpen, setDlgApproveChangeOpen] = useState(false);
    const confirmDlg = useConfirmation();

    useEffect(() => {
        if (betriebLoader.data) {
            const objectToSet = {...betriebLoader.data};
            if (objectToSet.produktion) {
                if (objectToSet.produktion.tagesarbeitszeitVon) {
                    const [hours, minutes] = objectToSet.produktion.tagesarbeitszeitVon.split(":");
                    objectToSet.produktion.tagesarbeitszeitVonAsDate = new Date();

                    objectToSet.produktion.tagesarbeitszeitVonAsDate.setHours(hours);
                    objectToSet.produktion.tagesarbeitszeitVonAsDate.setMinutes(minutes);
                }
                if (objectToSet.produktion.tagesarbeitszeitBis) {
                    const [hours, minutes] = objectToSet.produktion.tagesarbeitszeitBis.split(":");
                    objectToSet.produktion.tagesarbeitszeitBisAsDate = new Date();
                    objectToSet.produktion.tagesarbeitszeitBisAsDate.setHours(hours);
                    objectToSet.produktion.tagesarbeitszeitBisAsDate.setMinutes(minutes);
                }
            }
            if (objectToSet.betriebstyp.id !== INDUSTRIE) {
                objectToSet.produktion = {};
                objectToSet.wasserversorgung = {};
            }
            setValues(objectToSet);
            setTouchedValues({});
            if (objectToSet.freigabestatus === "BEANTRAGT") {
                setFreigabeNeeded(true);
            } else {
                setFreigabeNeeded(false);
            }
            if (currentVersion === null) setCurrentVersion(_.cloneDeep(objectToSet));
            logger.debug("Geladender Betrieb", betriebLoader.data);
        }
    }, [props.betriebsId, setValues, setTouchedValues, betriebLoader.data, currentVersion, props.modus]);

    useEffect(() => {
        if (stammdatenAntragLoader.data && stammdatenAntragLoader.data.stammdaten) {
            setStammdatenantrag(stammdatenAntragLoader.data.stammdaten);
            if (stammdatenAntrag) {
                setDlgApproveChangeOpen(true);
            }
        }
    }, [props.betriebsId, setStammdatenantrag, stammdatenAntrag, stammdatenAntragLoader.data]);

    useEffect(() => {
        if (touchedValues.betriebsstatus && isFinalStatus(values.betriebsstatus?.id)) {
            confirmDlg({
                title: "Betrieb stilllegen",
                description:
                    "Beim Stilllegen des Betriebs werden alle dem Betrieb zugeordneten Anlagen und Messstellen ebenfalls stillgelegt!",
                onClose: () => {
                    values.betriebsstatus = {
                        id: "IN_BETRIEB",
                        value: "in Betrieb",
                    };
                    setValues(values);
                }
            });
        }
    }, [touchedValues.betriebsstatus, values.betriebsstatus, confirmDlg, values, setValues]);

    useEffect(() => {
        if (userHasAnyRole([SYSTEMADMIN, FACHADMIN, ZUST_SBD, BETREIBER, BEAUFTRAGTER])) {
            props.setToggleAllowed(true);
        } else {
            props.setToggleAllowed(false);
        }
    }, [betriebLoader, props]);

    const handleChangeLage = (lage) => {
        const tmpValues = {...values};
        tmpValues.lage = lage;
        setValues(tmpValues);
    };

    const setBetriebsdatenWithValidate = (betriebsdaten) => {
        setValues(betriebsdaten);
        setErrors(null);
    };

    const handleStammdatenChange = (betrieb) => {
        setSaveActionLoading(true);

        async function uploadData() {
            try {
                await postStammdaten(betrieb, values.id);
                toast.success("Änderungsantrag erfolgreich eingereicht.");
                setDlgRequestChangeOpen(false);
                setStammdatenantrag({});
            } catch (e) {
                logger.error("Error uploading betriebsstammdaten", e);
                if (e && e.response && e.response.status === 409) {
                    toast.error("Es existiert bereits ein Änderungsantrag. Bitte warten Sie auf dessen Bearbeitung.");
                    setDlgRequestChangeOpen(false);
                    setStammdatenantrag({});
                } else if (e && e.response && e.response.status === 400 && e.response.data.validationErrors) {
                    const errorMessage = Object.values(e.response.data.validationErrors)[0];
                    toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                    setStammdatenErrors(e.response.data.validationErrors || null);
                } else {
                    toast.error("Es gab einen unbekannten Fehler beim Einreichen des Änderungsantrags.");
                }
            }
            setSaveActionLoading(false);
        }

        uploadData();
    };

    const prepareForUpload = (auditInfo = null) => {
        const betrieb = _.cloneDeep(values);
        betrieb.betreiber = betrieb.betreiber.id;
        betrieb.betriebstyp = "" + betrieb.betriebstyp.id;
        if (betrieb.betriebsstatus) {
            betrieb.betriebsstatus = betrieb.betriebsstatus.id;
        }
        if (betrieb.betriebstyp !== INDUSTRIE) {
            delete betrieb.produktion;
            delete betrieb.wasserversorgung;
        }
        if (betrieb.produktion) {
            if (betrieb.produktion.tagesarbeitszeitVonAsDate) {
                betrieb.produktion.tagesarbeitszeitVon = `${leftPad(betrieb.produktion.tagesarbeitszeitVonAsDate.getHours(), 2)}:${leftPad(
                    betrieb.produktion.tagesarbeitszeitVonAsDate.getMinutes(),
                    2
                )}`;
            } else {
                delete betrieb.produktion.tagesarbeitszeitVonAsDate;
            }
            if (betrieb.produktion.tagesarbeitszeitBisAsDate) {
                betrieb.produktion.tagesarbeitszeitBis = `${leftPad(betrieb.produktion.tagesarbeitszeitBisAsDate.getHours(), 2)}:${leftPad(
                    betrieb.produktion.tagesarbeitszeitBisAsDate.getMinutes(),
                    2
                )}`;
            } else {
                delete betrieb.produktion.tagesarbeitszeitBisAsDate;
            }
        }
        betrieb.zustaendigeBearbeiter = betrieb.zustaendigeBearbeiter.map((zust) => {
            return {
                id: zust.id,
                bearbeiter: zust.bearbeiter.datascoutId,
            };
        });
        betrieb.zustaendigePersonen = betrieb.zustaendigePersonen.map((zust) => {
            return {
                id: zust.id,
                person: zust.person.id,
                zustaendig: zust.zustaendig.map((zustaendigkeit) => zustaendigkeit.id),
            };
        });
        if (betrieb.kontakte) {
            betrieb.kontakte = betrieb.kontakte.map((kontakt) => {
                const objectToReturn = {...kontakt};
                objectToReturn.anrede = objectToReturn.anrede.id;
                if (objectToReturn.titel) {
                    objectToReturn.titel = objectToReturn.titel.id;
                }
                return objectToReturn;
            });
        }
        if (betrieb.anlageToAufnehmendeanlage) {
            const aufnehmend = {};
            betrieb.anlageToAufnehmendeanlage.forEach((anlage) => {
                const key = anlage.id;
                aufnehmend[key] = anlage.aufnahme.id;
            });
            betrieb.anlageToAufnehmendeanlage = aufnehmend;
        }
        if (auditInfo) {
            betrieb.auditInfo = auditInfo;
        }
        return betrieb;
    };

    function getRequestChangeContent(approve = false) {
        const itemSize = approve ? 5 : 6;
        return (
            <div className={"w-100"}>
                <Grid container spacing={1}>
                    {approve && (
                        <Grid item xs={itemSize}>
                            <b>Stammdatenwerte</b>
                        </Grid>
                    )}
                    {approve && (
                        <Grid item xs={itemSize}>
                            <b>beantragte Werte</b>
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("bezeichnung", "bezeichnungRO", "Bezeichnung", "text", true, {className: "w-100"})}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("bezeichnung", "bezeichnung", "Bezeichnung", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveBezeichnung", "approveBezeichnung", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("muttergesellschaft", "muttergesellschaftRO", "Muttergesellschaft", "text", true, {
                            className: "w-100",
                        })}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("muttergesellschaft", "muttergesellschaft", "Muttergesellschaft", "text", false, {
                            className: "w-100",
                        })}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveMuttergesellschaft", "approveMuttergesellschaft", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("url", "urlRO", "Webadresse", "text", true, {className: "w-100"})}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("url", "url", "Webadresse", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveUrl", "approveUrl", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderCheckbox("betreiberAdresse", "betreiberAdresse", "Betriebsadresse=Betreiber", true)}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderCheckbox("betreiberAdresse", "betreiberAdresse", "Betriebsadresse=Betreiber", false, {
                            forId: "betreiberAdresseInDialog",
                        })}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveBetreiberAdresse", "approveBetreiberAdresse", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("adresse.strasse", "adresse.strasseRO", "Straße", "text", true, {className: "w-100"})}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("strasse", "strasse", "Straße", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveStrasse", "approveStrasse", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("adresse.hausnummer", "adresse.hausnummerRO", "Haus-Nr.", "text", true, {
                            className: "w-100",
                        })}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("hausnummer", "hausnummer", "Haus-Nr.", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveHausnummer", "approveHausnummer", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("adresse.plz", "adresse.plzRO", "PLZ", "text", true, {className: "w-100"})}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("plz", "plz", "PLZ", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approvePlz", "approvePlz", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={itemSize}>
                        {formFactory.renderInput("adresse.ort", "adresse.ortRO", "Ort", "text", true, {className: "w-100"})}
                    </Grid>
                    <Grid item xs={itemSize}>
                        {innerFormFactory.renderInput("ort", "ort", "Ort", "text", false, {className: "w-100"})}
                    </Grid>
                    {approve && (
                        <Grid item xs={2}>
                            {innerFormFactory.renderCheckbox("approveOrt", "approveOrt", "Übernehmen")}
                        </Grid>
                    )}
                    <Grid item xs={approve ? 10 : 12}>
                        {innerFormFactory.renderInput("kommentar", "kommentar", "Kommentar", "text", approve, {
                            multiline: true,
                            className: "w-100",
                        })}
                    </Grid>
                </Grid>
            </div>
        );
    }

    function handleClickRequestChangeOpen() {
        setDlgRequestChangeOpen(true);
    }

    function handleRequestChangeClose() {
        setDlgRequestChangeOpen(false);
    }

    function handleRequestChangeCloseOk() {
        const aenderung = {};

        aenderung.bezeichnung = stammdatenantrag.bezeichnung;
        aenderung.muttergesellschaft = stammdatenantrag.muttergesellschaft;
        aenderung.url = stammdatenantrag.url;
        aenderung.betreiberAdresse = stammdatenantrag.betreiberAdresse;
        aenderung.strasse = stammdatenantrag.strasse ? stammdatenantrag.strasse : null;
        aenderung.hausnummer = stammdatenantrag.hausnummer ? stammdatenantrag.hausnummer : null;
        aenderung.plz = stammdatenantrag.plz ? stammdatenantrag.plz : null;
        aenderung.ort = stammdatenantrag.ort ? stammdatenantrag.ort : null;
        aenderung.kommentar = stammdatenantrag.kommentar;
        handleStammdatenChange(aenderung);
    }

    function handleClickApproveChangeOpen() {
        setDlgApproveChangeOpen(true);
    }

    function handleApproveChangeCloseCancel() {
        setDlgApproveChangeOpen(false);
        setStammdatenantrag(null);
        toast.info("Daten wurden abgelehnt und der Antrag gelöscht");
        deleteStammdatenAntrag(props.betriebsId).catch(() => {
        });
    }

    function handleApproveChangeCloseOk() {
        const valuesToChange = {...values};
        if (stammdatenantrag.approveBezeichnung) {
            valuesToChange.bezeichnung = stammdatenantrag.bezeichnung;
        }
        if (stammdatenantrag.approveMuttergesellschaft) {
            valuesToChange.muttergesellschaft = stammdatenantrag.muttergesellschaft;
        }
        if (stammdatenantrag.approveUrl) {
            valuesToChange.url = stammdatenantrag.url;
        }
        if (stammdatenantrag.approveBetreiberAdresse) {
            valuesToChange.betreiberAdresse = stammdatenantrag.betreiberAdresse;
        }
        if (stammdatenantrag.approveStrasse) {
            valuesToChange.adresse.strasse = stammdatenantrag.strasse;
        }
        if (stammdatenantrag.approveHausnummer) {
            valuesToChange.adresse.hausnummer = stammdatenantrag.hausnummer;
        }
        if (stammdatenantrag.approvePlz) {
            valuesToChange.adresse.plz = stammdatenantrag.plz;
        }
        if (stammdatenantrag.approveOrt) {
            valuesToChange.adresse.ort = stammdatenantrag.ort;
        }
        setValues(valuesToChange);
        deleteStammdatenAntrag(props.betriebsId).catch(() => {
        });
        toast.info("Daten wurden übernommen und der Antrag gelöscht");
        setDlgApproveChangeOpen(false);
        setStammdatenantrag(null);
    }

    const freigabe = async (freigabeOpts = {doppelErfassungConfirmed: false}) => {
        const e = validate();
        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const freigabeToSend = prepareForUpload();
        delete freigabeToSend.id;
        if (freigabeOpts.doppelErfassungConfirmed) {
            freigabeToSend.skipBetriebExistsCheck = true;
        }
        logger.debug("Freigabeanfrage wird eingereicht", freigabeToSend);
        try {
            await postBetrieb(freigabeToSend);
            toast.success("Betrieb erfolgreich beantragt");
            props.history.replace("/");
        } catch (ex) {
            setSaveActionLoading(false);
            if (ex.response?.data?.validationErrors) {
                setErrors(ex.response.data.validationErrors || {});
                const errorMessage = Object.values(ex.response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
            } else if (ex.response?.data?.possibleSuppressorFlag === "skipBetriebExistsCheck") {
                confirm({
                    title: "Achtung potentielle Doppelerfassung!",
                    description: ex.response?.data.message
                        + '\n\n Um den Speichervorgang fortzusetzen bestätigen Sie bitte die Richtigkeit der von Ihnen erfassten Daten.',
                    onSubmit: () => freigabe({doppelErfassungConfirmed: true}),
                    onClose: () => {
                    },
                });
            } else {
                handleApiException(ex, "Error sending Betriebsfreigabeantrag.");
            }
        }
    };

    const save = async () => {
        const e = validate();
        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload();
        logger.debug("Save", objectToSave);
        try {
            await putBetriebsdaten(objectToSave);
            refetchHistoryData();
            toast.success("Betrieb erfolgreich gespeichert");
            props.history.replace(routes.BETRIEBSAKTE_RAW + "/" + props.betriebsId + "?modus=l");
        } catch (ex) {
            setSaveActionLoading(false);
            const errorMessage = Object.values(ex.response.data.validationErrors)[0];
            toast.warn("Validierung fehlgeschlagen: " + errorMessage);
            if (ex.response) {
                setErrors(ex.response.data.validationErrors || null);
            }
            logger.error("Error saving betrieb", ex, values);
        }
    };

    const saveAsAdmin = async (auditInfo = null) => {
        const e = validate();
        logger.debug(e);
        if (e && Object.keys(e).length > 0) {
            return;
        }
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload(auditInfo);
        logger.debug("SaveAsAdmin", objectToSave);
        try {
            await putBetrieb(objectToSave);
            refetchHistoryData();
            toast.success("Betrieb erfolgreich gespeichert");
            props.history.replace(routes.BETRIEBSAKTE_RAW + "/" + props.betriebsId + "?modus=l");
            if (touchedValues.bezeichnung || touchedValues.betriebsstatus) {
                props.reloadNavigation();
            }
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            let newErrors = null;
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                newErrors = ex.response.data.validationErrors;
            }
            if (response?.data?.possibleSuppressorFlag === "anlageToAufnehmendeanlage") {
                setStilllegenDialogOpen(true);
                if (newErrors) {
                    newErrors = {
                        ...newErrors,
                        betriebsstatus: "Die aufnehmenden Kläranlagen des Betriebs müssen erst ersetzt werden!",
                    };
                } else {
                    newErrors = {betriebsstatus: "Die aufnehmenden Kläranlagen des Betriebs müssen erst ersetzt werden!"};
                }
            }
            if (response?.data?.auditInfoViolation) {
                requestAuditInfo(response.data);
            } else if (!newErrors) {
                handleApiException(ex, "Error saving Betriebsdaten");
            }
            setErrors(newErrors);

            logger.debug("Error saving betrieb as admin", ex, values);
        }
    };

    const editFreigabe = () => {
        setFreigabeDialogOpen(true);
    };
    const requestAuditInfo = (violation) => {
        setAuditInfoDialogOpen(true);
        setAuditInfoDialogViolation(violation);
    };

    function getSaveButtonLabel() {
        if (betriebLoader.data && betriebLoader.data.freigabestatus === "ABGEWIESEN") {
            return "Freigabe erneut beantragen";
        }

        return "Speichern";
    }

    const renderButtonBar = (anlegen) => {
        if (anlegen) {
            return (
                <EAButtonBar
                    style={{
                        marginTop: "var(--buttonBar-spacing-top)",
                        marginBottom: "var(--vertical-spacing)",
                        marginRight: "10px",
                    }}
                >
                    {formFactory.renderButton("freigabe", "freigabe", "Freigabe anfordern", freigabe, {
                        "data-cy": "freigabe",
                        color: "primary",
                    })}
                </EAButtonBar>
            );
        }
        return (
            <EAButtonBar
                style={{
                    marginTop: "var(--buttonBar-spacing-top)",
                    marginBottom: "var(--vertical-spacing)",
                    marginRight: "10px",
                    marginLeft: "5px",
                }}
            >
{userHasAnyRole([BETREIBER, BEAUFTRAGTER]) &&
                    formFactory.renderButton(
                        "aenderungsantragEinreichen",
                        "aenderungsantragEinreichen",
                        "Änderungsantrag erstellen",
                        () => handleClickRequestChangeOpen(),
                        {
                            "data-cy": "aenderungsantragEinreichen",
                        }
                    )}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    stammdatenantrag &&
                    stammdatenAntragLoader.data &&
                    stammdatenAntragLoader.data.stammdaten &&
                    Object.keys(stammdatenAntragLoader.data.stammdaten).length > 0 &&
                    formFactory.renderButton(
                        "aenderungsantragPruefen",
                        "aenderungsantragPruefen",
                        "Änderungsantrag prüfen",
                        () => handleClickApproveChangeOpen(),
                        {
                            "data-cy": "aenderungsantragPruefen",
                            color: "primary",
                        }
                    )}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) &&
                    formFactory.renderButton("saveAsAdmin", "saveAsAdmin", getSaveButtonLabel(), () => saveAsAdmin(), {
                        "data-cy": "saveZustSbd",
                        color: "primary",
                    })}
                {userHasAnyRole([BETREIBER, BEAUFTRAGTER]) &&
                    formFactory.renderButton("save", "save", getSaveButtonLabel(), save, {
                        "data-cy": "saveBetreiber",
                        color: "primary",
                    })}
                {userHasAnyRole([FACHADMIN, SYSTEMADMIN]) &&
                    freigabeNeeded &&
                    formFactory.renderButton("editFreigabe", "editFreigabe", "Freigabe bearbeiten", editFreigabe, {
                        "data-cy": "editFreigabe",
                        color: "primary",
                    })}
            </EAButtonBar>
        );
    };

    const buildTabs = () => {
        const options = [tabBetrieb];

        if (props.betriebstyp.id === INDUSTRIE) {
            options.push(tabWasserversorgung);
        }
        options.push(tabZustaendigkeiten);
        return options;
    };

    const getTabErrors = () => {
        const tabErrors = {};
        if (errors && Object.keys(errors).length > 0) {
            for (const error in errors) {
                if (!errors.hasOwnProperty(error)) {
                    continue;
                }
                if (error.startsWith("wasserversorgung")) {
                    if (Object.keys(errors[error]).length > 0) tabErrors[tabWasserversorgung] = true;
                } else if (
                    error.startsWith("zustaendigePersonen") ||
                    error.startsWith("zustaendigeBearbeiter") ||
                    error.startsWith("kontakte")
                ) {
                    tabErrors[tabZustaendigkeiten] = true;
                } else {
                    tabErrors[tabBetrieb] = true;
                }
            }
        }
        return tabErrors;
    };

    const freigeben = async () => {
        setSaveActionLoading(true);
        try {
            await postFreigabe({
                betriebId: values.id,
                kommentar: freigabeKommentar,
                neuerStatus: "FREIGEGEBEN",
            });
            await reFetchBetrieb();
            props.reloadNavigation();
            props.history.replace(routes.BETRIEBSAKTE_RAW + "/" + props.betriebsId + "?modus=l");
            toast.success("Betrieb freigegeben");
        } catch (e) {
            if (!isApiCancel(e)) {
                logger.error("Error freigeben betrieb", e);
                toast.error("Freigeben fehlgeschlagen");
            }
        }
        setFreigabeDialogOpen(false);
        setSaveActionLoading(false);
    };

    const ablehnen = async () => {
        confirm({
            title: "Zurückweisung bestätigen",
            description: "Wollen Sie die Freigabe für den Betrieb wirklich zurückweisen?",
            onSubmit: async () => {
                setSaveActionLoading(true);
                try {
                    await postFreigabe({
                        betriebId: values.id,
                        kommentar: freigabeKommentar,
                        neuerStatus: "ABGEWIESEN",
                    });
                    toast.success("Betrieb abgelehnt");
                    await reFetchBetrieb();
                } catch (e) {
                    logger.error("Error ablehnen betrieb", e);
                    toast.error("Betrieb ablehnen fehlgeschlagen");
                }
                setFreigabeDialogOpen(false);
                setSaveActionLoading(false);
            },
            onClose: () => {
            },
        });
    };

    if (betriebLoader.loading || saveActionLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress/>
            </div>
        );
    }
    const backgroundColor = values.history ? {background: "#FFFFFF", filter: "sepia()"} : {};
    return (
        <EABetriebsakteMainContainer style={backgroundColor}>
            <FreigabeDialog
                label="Betrieb"
                open={freigabeDialogOpen}
                onClose={() => setFreigabeDialogOpen(false)}
                kommentar={freigabeKommentar}
                onKommentarChange={(newValue) => setFeigabeKommentar(newValue.currentTarget.value)}
                onAblehnen={() => ablehnen()}
                onFreigabe={() => freigeben()}
            />
            <EADialog
                open={dlgRequestChangeOpen}
                titleChildren={"Änderungsantrag erstellen (Betriebsdaten)"}
                content={getRequestChangeContent()}
                buttons={
                    <React.Fragment>
                        <EAButton
                            id={"eins"}
                            data-cy={"btnRequestChangeAbbrechen"}
                            label={"Abbrechen"}
                            onClick={handleRequestChangeClose}
                        />
                        <EAButton
                            id={"ok"}
                            data-cy={"btnRequestChangeOk"}
                            label={"Änderungsantrag einreichen"}
                            color="primary"
                            onClick={handleRequestChangeCloseOk}
                        />
                    </React.Fragment>
                }
            />
            <EADialog
                open={dlgApproveChangeOpen}
                titleChildren={"Änderungsantrag prüfen (Betriebsdaten)"}
                content={getRequestChangeContent(true)}
                buttons={
                    <React.Fragment>
                        <EAButton
                            id={"antragReject"}
                            data-cy={"btnApproveChangeReject"}
                            label={"Änderungen verwerfen"}
                            onClick={handleApproveChangeCloseCancel}
                        />
                        <EAButton
                            id={"antragApprove"}
                            data-cy={"btnApproveChangeApprove"}
                            label={"Änderungen übernehmen"}
                            color="primary"
                            onClick={handleApproveChangeCloseOk}
                        />
                    </React.Fragment>
                }
            />
            <StilllegenDialog
                open={stilllegenDialogOpen}
                betriebsId={props.betriebsId}
                onCancel={() => {
                    const objectToSet = {...values};
                    delete objectToSet.anlageToAufnehmendeanlage;
                    setValues(objectToSet);
                    setStilllegenDialogOpen(false);
                }}
                onOk={(anlagen) => {
                    const objectToSet = {...values};
                    objectToSet.anlageToAufnehmendeanlage = anlagen;
                    setValues(objectToSet);
                    setStilllegenDialogOpen(false);
                }}
            />
            <AuditInfoDialog
                open={auditInfoDialogOpen}
                onClose={() => setAuditInfoDialogOpen(false)}
                violation={auditInfoDialogViolation}
                onAuditInfoSet={(aud) => saveAsAdmin(aud)}
                onVerwerfen={() => {
                    setAuditInfoDialogOpen(false);
                    reFetchBetrieb().catch((e) => handleApiException(e, "Error on AuditInfoDialog.onVerwerfen"));
                }}
            />
            <EATabs
                value={selectedTab}
                onChange={(newSelectedTab) => setSelectedTab(newSelectedTab)}
                options={buildTabs()}
                errors={getTabErrors()}
            />
            <EABetriebsakteDatenContainer>
                {selectedTab === tabBetrieb && (
                    <Betriebsdaten
                        data={values}
                        errors={errors}
                        betriebsId={props.betriebsId}
                        onChangeLage={handleChangeLage}
                        onChangeWithValidate={setBetriebsdatenWithValidate}
                        formFactory={formFactory}
                        onStammdatenChange={handleStammdatenChange}
                        historieFeld={props.modus === "l" ? (
                            <EAHistorySelector
                                data={historyData}
                                loading={historyLoading}
                                additionalColumns={[
                                    createCalculatedColumn(
                                        "betriebsstatus",
                                        (row) => {
                                            return row.betriebsstatus.value;
                                        },
                                        "Status",
                                        {padding: "2px"}
                                    ),
                                ]}
                                onClickSelect={(row) => {
                                    if (props.modus === "s")
                                        props.history.push(props.location.pathname + _.replace(props.location.search, "modus=s", "modus=l"));
                                    if (row.timestamp !== "aktuell") setValues({...row, history: true});
                                    else setValues({...row});
                                }}
                                onCancel={() => setValues({...currentVersion})}
                            />
                        ) : null}
                        {...props}
                    />
                )}
                {selectedTab === tabWasserversorgung && (
                    <Wasserversorgung data={values} errors={errors} formFactory={formFactory} {...props} />
                )}
                {selectedTab === tabZustaendigkeiten && (
                    <Zustaendigkeiten
                        data={values}
                        errors={errors}
                        formFactory={formFactory}
                        betriebsId={props.betriebsId}
                        parentId={props.betriebsId}
                        onChange={(name, data) => {
                            const valuesToSet = {...values};
                            _.set(valuesToSet, name, data);
                            setValues(valuesToSet);
                            setErrors(validateProperty(name, data));
                        }}
                        {...props}
                    />
                )}
            </EABetriebsakteDatenContainer>
            {renderButtonBar(!props.betriebsId)}
        </EABetriebsakteMainContainer>
    );
}

export default BetriebsdatenView;
